import { useCallback, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

import { TargetSelectorContext } from '@/contexts/TargetSelectorContextDefinition';

export function TargetSelectorProvider({ children }: { children: ReactNode }) {
  const [isTargetSelectorOpen, setIsTargetSelectorOpen] = useState(false);
  const openTargetSelector = useCallback(() => setIsTargetSelectorOpen(true), []);
  const closeTargetSelector = useCallback(() => setIsTargetSelectorOpen(false), []);
  const value = useMemo(
    () => ({
      isTargetSelectorOpen,
      openTargetSelector,
      closeTargetSelector,
    }),
    [closeTargetSelector, isTargetSelectorOpen, openTargetSelector]
  );

  return <TargetSelectorContext.Provider value={value}>{children}</TargetSelectorContext.Provider>;
}
